import { Helmet } from 'react-helmet-async';
// sections
import CareersDashboardView from 'src/sections/dashboard/view/careers-dashboard-view';

// ----------------------------------------------------------------------

export default function CareersDashboardPage() {
  return (
    <>
      <Helmet>
        <title>MyFVSD | Student Careers</title>
      </Helmet>

      <CareersDashboardView />
    </>
  );
}
